import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'facility_name_local_language_as_per_business_license'

export const dataPointDefinition = {
  retracedId: 'facility_name_local_language_as_per_business_license',
  name: 'Facility Name (in local language as per business license):',
  description: 'Only applicable if your facility has a name/also has a name in a language other than English.',
  meta: {
    slcpMeta: {
      key: 'fp-bi-3',
      number: 'FP-BAS-6',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {type: 'object', properties: {value: {type: 'string'}}, required: ['value']},
  externalIds: [{id: 'fp-bi-3', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27230,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
